import { CopyOutlined } from "@ant-design/icons";
import { Tooltip, Table } from "antd";
import React, { useEffect } from "react";
import {
  Button,
  Col,
  ModalHeader,
  ModalBody,
  Row,
  Card,
} from "reactstrap";
import toast from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { formatDatePaymentLink } from "../utils/script/indexUtils";
import "../utils/detailsModal.css";
import { useQuery } from "react-query";
import { getCollectLinkTransactions } from "../service/api";

const DetailLinkModal = ({ modalDetail, setModalDetail, toggle, linkSelected, formattingDate, businessAccountSelected }) => {

  const MAXLENGTH_PAYMENTLINK = 60;
  const { paymentLink, amount, type, description, startDate, paymentStatus, clientEmail, paymentLinkExpiration, idClient } = linkSelected || {};

  console.log(linkSelected);
  const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
  const token = currentUser?.token;

  const { data: transactions, isLoading: isLoadingTransactions } = useQuery({
    queryKey: ["collectLinkTransactions", idClient, businessAccountSelected?.id, token],
    queryFn: getCollectLinkTransactions,
    enabled: !!idClient && !!businessAccountSelected?.id && !!token
  });

  console.log(linkSelected);

  const handleCopyLink = () => {
    if (!paymentLink) {
      toast.info("Aucun lien à copier");
    } else {
      navigator.clipboard.writeText(paymentLink);
      toast.success("Lien copié avec succès");
    }
  };

  const truncatePaymentLink = (link) => {
    if (link.length <= MAXLENGTH_PAYMENTLINK) return link;
    return link.slice(0, MAXLENGTH_PAYMENTLINK / 2) + '...' + link.slice(-MAXLENGTH_PAYMENTLINK / 2);
  }



  useEffect(() => {
    console.log(linkSelected)
  }, [linkSelected]);

  const transactionColumns = [
    {
      title: "Client",
      dataIndex: "clientFullName",
      key: "clientFullName",
      render: (name) => <span>{name}</span>
    },
    {
      title: "Téléphone",
      dataIndex: "clientNumber",
      key: "clientNumber",
      render: (phone) => <span>{phone}</span>
    },
    {
      title: "Méthode",
      dataIndex: "paymentMethodName",
      key: "paymentMethodName",
      render: (method) => <span>{method}</span>
    },
    {
      title: "Montant",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (val, record) => (
        <span>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: record.currency }).format(val)}
        </span>
      )
    },
    {
      title: "Statut",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span className={`lnk-status ${status === "SUCCESS" ? "lnk-success" : "lnk-danger"}`}>
          {status === "SUCCESS" ? "Succès" : status || "—"}
        </span>
      )
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (ts) => (
        <span>
          {new Date(ts).toLocaleString('fr-FR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
          })}
        </span>
      )
    },
  ];

  return (
    <>
      <ModalHeader className="p-3" toggle={toggle}>
        <span className="modal-title">Détail du lien</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={6}>
            <Card className="lnk-card-detail">
              <div className="lnk-block">
                <p className="lnk-label">Description</p>
                <p className="lnk-description">
                  {description || "Aucune description fournie."}
                </p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Montant encaissé</p>
                <p className="lnk-amount">{new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'XOF'
                }).format(amount)}</p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Statut du paiement</p>
                <span
                  className={`lnk-status ${paymentStatus === "SUCCESS" ? "lnk-success" : "lnk-danger"}`}
                >
                  {paymentStatus === "SUCCESS" ? "Payé" : "Non payé" || "Indéfini"}
                </span>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Date de création du lien</p>
                <p className="lnk-date lnk-value">{formatDatePaymentLink(startDate)}</p>
              </div>
            </Card>
          </Col>
          <Col lg={6} className="mt-2">
            <Card className="lnk-card-detail">
              <div className="lnk-block">
                <p className="lnk-label">Lien</p>
                <div className="lnk-copy-container">
                  <input
                    type="text"
                    readOnly
                    value={truncatePaymentLink(paymentLink) || "Aucun lien"}
                    className="lnk-copy-input"
                  />
                  <Tooltip title="Copier le lien">
                    <CopyOutlined
                      className="lnk-copy-icon"
                      onClick={handleCopyLink}
                    />
                  </Tooltip>
                </div>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Type de lien</p>
                <p className="lnk-value">{type || "Lien de collecte"}</p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Email du destinataire</p>
                <p className="lnk-value">
                  {clientEmail ? clientEmail : "Non défini"}
                </p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Date d'expiration du lien</p>
                <p className="lnk-date lnk-value">{formatDatePaymentLink(paymentLinkExpiration)}</p>
              </div>
            </Card>
          </Col>
        </Row>

        <div className="mt-4">
          <p style={{ fontSize: 15, fontWeight: 600, color: '#1d1d1f', marginBottom: 12 }}>
            Transactions ({transactions?.length})
          </p>
          <Table
            columns={transactionColumns}
            dataSource={transactions}
            loading={isLoadingTransactions}
            pagination={{ pageSize: 5, size: 'small' }}
            scroll={{ x: true }}
            size="small"
            locale={{ emptyText: "Aucune transaction pour ce lien" }}
          />
        </div>
      </ModalBody>
      <div className="mt-2">
        <Button color="secondary" onClick={() => setModalDetail(false)}>
          Fermer
        </Button>
      </div>
    </>
  );
};

export default DetailLinkModal;
